import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray"; //@ts-check

import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { default as MaterialIcon } from '@material-ui/core/Icon';
import Formatter from '../../formatter';

var PinIcon = function PinIcon(_ref) {
  var classes = _ref.classes,
      icon = _ref.icon,
      label = _ref.label;

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      changeToAvatar = _React$useState2[0],
      setChangeToAvatar = _React$useState2[1];

  return React.createElement(React.Fragment, null, changeToAvatar ? React.createElement(Formatter.LetterAvatar, {
    text: label,
    classes: {
      letterAvatar: classes.letterAvatar
    }
  }) : React.createElement(MaterialIcon, {
    classes: {
      root: classes.iconRoot
    },
    className: classes.icon
  }, React.createElement("img", {
    className: classes.imgIcon,
    src: icon,
    onError: function onError() {
      setChangeToAvatar(true);
    }
  })));
};

var styles = function styles() {
  return {
    icon: {
      fontSize: '0.8125rem'
    },
    iconRoot: {
      textAlign: 'center',
      height: '100%'
    },
    imgIcon: {
      display: 'block',
      marginLeft: 'auto',
      marginRight: 'auto',
      width: '100%'
    },
    letterAvatar: {
      fontSize: '0.5rem',
      width: '13px',
      height: '13px'
    }
  };
};

export default withStyles(styles, {
  name: 'ECPinIcon'
})(PinIcon);